import { DirectiveOptions } from 'vue';

const directive: DirectiveOptions =  {
    inserted(el: HTMLElement) {
        const elTarget = document.getElementById(el.getAttribute('data-target') || '');
        const elTargetNavbar = document.getElementById(el.getAttribute('data-target-navbar') || '');

        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (elTarget) {
                elTarget.classList.toggle('show');
            }
            if (elTargetNavbar) {
                elTargetNavbar.classList.toggle('navbar-expanded');
            }
        });
    }
};

export default directive;
